import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

const LoginPage = () => import('@/pages/LoginPage')
const AccountPage = () => import('@/pages/AccountPage')
const DashboardPage = () => import('@/pages/core/DashboardPage')
const ManagementPage = () => import('@/pages/core/ManagementPage')
const PoiMapPage = () => import('@/pages/core/PoiMapPage')
const ReportPage = () => import('@/pages/core/ReportPage')

// management
const AutomatedMessagePage = () => import('@/pages/management/AutomatedMessagePage.vue')
const HeavyToolPage = () => import('@/pages/management/HeavyToolPage.vue')
const LogisticPage = () => import('@/pages/management/LogisticPage.vue')
const OfficerPage = () => import('@/pages/management/OfficerPage.vue')
const OrganizationPage = () => import('@/pages/management/OrganizationPage.vue')
const ShelterPage = () => import('@/pages/management/ShelterPage.vue')

// logistic
const LogisticStoragePage = () => import('@/pages/management/logistic/StoragePage.vue')
const LogisticDistributionPage = () => import('@/pages/management/logistic/DistributionPage.vue')

// heavy tool
const HeavyToolStoragePage = () => import('@/pages/management/heavy-tool/StoragePage.vue')
const HeavyToolDistributionPage = () => import('@/pages/management/heavy-tool/DistributionPage.vue')

// report
const DisasterReportDetailPage = () => import('@/pages/report/disaster/ReportDetailPage.vue')

const ListDamage = () => import('@/pages/handling/damage/ListDamage')
const CreateDamage = () => import('@/pages/handling/damage/CreateDamage')
const DamageMap = () => import('@/pages/handling/damage/DamageMap')
const DisasterNameManagement = () => import('@/pages/handling/disaster-name/DisasterNameManagement')
const DisasterNameManagementCreate = () => import('@/pages/handling/disaster-name/CreateName')
const ListShelter = () => import('@/pages/handling/shelter/ListShelter')
const CreateShelter = () => import('@/pages/handling/shelter/CreateShelter')
const ShelterStatus = () => import('@/pages/handling/shelter/ShelterStatus')
const ListShelterStatus = () => import('@/pages/handling/shelter/ListShelterStatus')
const CreateShelterStatus = () => import('@/pages/handling/shelter/CreateShelterStatus')
const RequestMeasureStatus = () => import('@/pages/handling/RequestMeasureStatus')
const DisasterPreventionInfoMap = () => import('@/pages/handling/DisasterPreventionInfoMap')
const DocumentationPage = () => import('@/pages/DocumentationPage')
const LiveReport = () => import('@/pages/LiveReport')
const Test = () => import('@/components/SelectLocation')

Vue.use(VueRouter)

const getCurrentUser = 'Auth/getCurrentUser'
const isLoggedInPath = 'Auth/isLoggedIn'

function redirectToLogin (next, path) {
  next({
    name: 'login',
    query: {
      redirect: decodeURIComponent(path)
    }
  })
}

function checkSession (to, from, next) {
  store.dispatch(getCurrentUser)
    .then(() => {
      if (to.name === 'login') {
        next()
        return
      }

      const isLoggedIn = store.getters[isLoggedInPath]

      if (!isLoggedIn) {
        redirectToLogin(next, to.path)
        return
      }
      next()
    })
    .catch(err => {
      if (to.name === 'login') {
        next()
        return
      }
      alert(JSON.stringify(err.status))
      if (err.reponse && err.reponse.status === 401) {
        redirectToLogin(next, to.path)
      }
    })
}

const router = new VueRouter({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'Dashboard',
      component: DashboardPage
    },
    {
      path: '/map',
      redirect: '/map/poi/disaster/flood'
    },
    {
      path: '/map/poi/:type/:code',
      name: 'PoiMap',
      component: PoiMapPage
    },
    {
      path: '/report',
      name: 'Report',
      component: ReportPage
    },
    {
      path: '/management',
      name: 'Management',
      component: ManagementPage
    },
    {
      path: '/management/automated-message',
      name: 'AutomatedMessage',
      component: AutomatedMessagePage
    },
    {
      path: '/management/heavy-tool',
      name: 'HeavyTool',
      component: HeavyToolPage
    },
    {
      path: '/management/heavy-tool/storage',
      name: 'HeavyToolStorage',
      component: HeavyToolStoragePage
    },
    {
      path: '/management/heavy-tool/distribution',
      name: 'HeavyToolDistribution',
      component: HeavyToolDistributionPage
    },
    {
      path: '/management/logistic',
      name: 'Logistic',
      component: LogisticPage
    },
    {
      path: '/management/logistic/storage',
      name: 'LogisticStorage',
      component: LogisticStoragePage
    },
    {
      path: '/management/logistic/distribution',
      name: 'LogisticDistribution',
      component: LogisticDistributionPage
    },
    {
      path: '/management/officer',
      name: 'Officer',
      component: OfficerPage
    },
    {
      path: '/management/organization',
      name: 'Organization',
      component: OrganizationPage
    },
    {
      path: '/management/shelter',
      name: 'Shelter',
      component: ShelterPage
    },
    {
      path: '/report/disaster/:id',
      name: 'DisasterReportDetail',
      component: DisasterReportDetailPage
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/account',
      name: 'account',
      component: AccountPage
    },
    {
      path: '/monitor',
      component: LiveReport
    },
    {
      path: '/handling/name',
      name: 'DisasterNameManagement',
      component: DisasterNameManagement
    },
    {
      path: '/handling/name/_create',
      name: 'DisasterNameManagement:Create',
      component: DisasterNameManagementCreate
    },
    {
      path: '/handling/damage-conditions',
      name: 'Damage',
      component: ListDamage
    },
    {
      path: '/handling/damage-conditions/_create',
      name: 'Damage:Create',
      component: CreateDamage
    },
    {
      path: '/handling/damage-map',
      name: 'Damage:Map',
      component: DamageMap
    },
    {
      path: '/handling/shelter',
      name: 'Shelter',
      component: ListShelter
    },
    {
      path: '/handling/shelter/_create',
      name: 'Shelter:Create',
      component: CreateShelter
    },
    {
      path: '/handling/shelter-status',
      name: 'ShelterStatus',
      component: ShelterStatus
    },
    {
      path: '/handling/shelters/:id/statuses',
      name: 'ListShelterStatus',
      component: ListShelterStatus
    },
    {
      path: '/handling/shelters/:id/statuses/_create',
      name: 'ShelterStatus:Create',
      component: CreateShelterStatus
    },
    {
      path: '/handling/request-measure-status',
      component: RequestMeasureStatus
    },
    {
      path: '/handling/prevention-info-map',
      component: DisasterPreventionInfoMap
    },
    {
      path: '/docs',
      component: DocumentationPage
    },
    {
      path: '/test',
      component: Test
    }
  ],
  mode: 'history'
})

router.beforeEach(checkSession)

export default router
